import { apiClient } from "../../../Utilities/apiClient";
import { Tag, TagWithStats } from "../../../Resources/Data/Tags";

export interface TagResponse {
  tags: TagWithStats[];
}

export interface TagCreateResponse {
  tag: {
    identifiers: { id: number }[];
    generatedMaps: Tag[];
    raw: Tag[];
  };
}

export const tagService = {
  // Get all tags
  getAllTags: (): Promise<{ data: TagResponse }> => 
    apiClient.get('/trails/tags'),

  // Create a new tag
  createTag: (name: string): Promise<{ data: TagCreateResponse }> => 
    apiClient.post('/trails/tags', { name }),

  // Delete a tag by ID
  deleteTag: (id: number): Promise<{ data: { message: string } }> => 
    apiClient.delete(`/trails/tags/${id}`),

  // Validate tag name (client-side check before API call)
  validateTagName: (name: string): { isValid: boolean; error?: string } => {
    const trimmedName = name.trim();
    
    if (trimmedName.length < 2) {
      return { isValid: false, error: 'Tag name must be at least 2 characters long' };
    }
    
    if (trimmedName.length > 50) {
      return { isValid: false, error: 'Tag name must be less than 50 characters' };
    }
    
    if (!/^[a-zA-Z0-9\s\-_]+$/.test(trimmedName)) {
      return { isValid: false, error: 'Tag name can only contain letters, numbers, spaces, hyphens, and underscores' };
    }
    
    return { isValid: true };
  },

  checkTagNameExists: async (name: string, existingTags: Pick<Tag, 'name'>[]): Promise<boolean> => {
    const trimmedName = name.trim().toLowerCase();
    return existingTags.some(tag => tag.name.toLowerCase() === trimmedName);
  }
};